import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// API to fetch customer memberships with optional filters
export const getCustomerMemberships = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/CustomerMembership/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching customer memberships:", error);
    throw error;
  }
};

// API to insert or update a customer membership
export const saveCustomerMembership = async (membershipData) => {
  try {
    console.log("API call - saveCustomerMembership:", membershipData);
    const response = await axios.post(`${BASE_URL}/api/CustomerMembership/save`, membershipData, {
      headers: getAuthHeader(),
    });
    console.log("API response - saveCustomerMembership:", response.data);
    return response.data;
  } catch (error) {
    console.error("API error - saveCustomerMembership:", error);
    throw error;
  }
};
